module.exports = __webpack_public_path__ + "static/eeroaarnio-2e3c72f1f135c6641b92170c7d3c19bb.svg";